const queryParam = (url, param) => {
    if (!url) {
         return null;
     }
     const searchParams = new URLSearchParams(url.split('?') [1]);
     const value = searchParams.get(param);
     return value;
 }

 export default queryParam